import React from 'react';
import "./viewmapform.css"

function Card (props){

    return(
        <div >
            {props.children}
        </div>
    )
}
export default Card ;